import { Box } from '@medly-components/core';
import { Header as StyledHeader } from 'components';
import { BackButtonStyled } from 'components/layout/Header/BackButton/BackButton.styled';
import styled from 'styled-components';

export const Header = styled(StyledHeader)`
    @media (min-width: ${({ theme }) => theme.breakpoints.M.min}px) {
        padding: 1.3rem 4rem;
    }

    ${BackButtonStyled} {
        @media (max-width: ${({ theme }) => theme.breakpoints.M.min}px) {
            display: none;
        }
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        padding: 0.9rem 2.4rem;
        min-height: 4.8rem;

        h3 {
            font-size: 1.6rem;
            line-height: 2.2rem;
        }
    }
`;

export const HeaderContent = styled(Box)`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
`;
